import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { baseUrl } from "../../shared/Fetch";
import { useEffect, useState } from "react";
import { FileUpload } from "primereact/fileupload";

interface IProps {
    singleData: any,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

const schema = yup.object({
});

export const Form = (props: IProps) => {
    const [saveDis, setSaveDis] = useState(false);
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState(false);
    const [imageType, setImageType] = useState<string>("");
    const [resumeFile, setResumeFile] = useState<File | null | any>(null);

    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<any>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const onSubmit = (data: any) => {
        if (!image) {
            props.toast.current.show({ severity: 'error', detail: "Please Upload Image First", life: 3000 });
        } else {
            setSaveDis(true);
            saveToDB(data);
        }
    }

    const saveToDB = async (data: any) => {
        setLoading(true);
        const method = props.singleData.id != null ? "PUT" : "POST";
        const message = props.singleData.id != "" ? "Updated Successfully" : "Added Successfully";
        const formData = new FormData();
        formData.append('images', resumeFile);
        formData.append('gallery', JSON.stringify(data));
        const params = {
            method: method,
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        const response = await fetch(`${baseUrl}Gallery?typeoffile=${imageType}`, params);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
            setResumeFile(null)
            setSaveDis(false);
        } else {
            setSaveDis(false);
        }
        setLoading(false);
        setImage(false);
    }


    const onUpload = (event: any) => {
        const file = event.files[0];
        setImageType(event.files[0].type.split("/")[1]);
        if (event.files[0].type === "image/png" || event.files[0].type === "image/jpeg" || event.files[0].type === "image/jpg") {
            if (event.files[0].size > 1024 * 1024 * 2) {
                props.toast.current.show({ severity: 'error', content: "Image File should be less than 2 MB." });
                event.options.clear();
            } else {
                setResumeFile(file);
                setImage(true);
                event.options.clear();
            }
        } else {
            props.toast.current.show({ severity: 'error', content: "Please Choose A Image File." });
            setImage(true);

            event.options.clear();
        }
        setResumeFile(file);
        props.toast.current.show({ severity: 'success', summary: 'Success', detail: "Screenshot Saved", life: 3000 });

    };

    const onHide = () => {
        props.hideDialog();
        setImage(false);
        setResumeFile(null)
    }

    useEffect(() => {
        reset(props.singleData);
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '40vw', maxWidth: '600px' }} header="Add/Edit Image Gallery " modal className="p-fluid rounded-2xl shadow-lg" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <div className="col-12">
                    <div className="card border-1 surface-border p-4 flex flex-column items-center gap-3">
                        <FileUpload chooseLabel="Choose Image" mode="basic" name="images" accept="image/*" customUpload uploadHandler={onUpload} auto />
                        {resumeFile && (
                            <img
                                src={URL.createObjectURL(resumeFile)}
                                alt="Preview"
                                className="rounded-xl shadow-md mt-3 max-h-32 object-contain"

                            />
                        )}
                    </div>
                </div>
                <div className="col-12 flex justify-content-end gap-3 mt-4">
                    <Button loading={loading} label="Save" type="submit" disabled={saveDis} className="p-button-rounded w-32" />
                    <Button label="Close" type="button" onClick={onHide} className="p-button-rounded p-button-outlined w-32" />
                </div>
            </form>
        </Dialog>
    );
}

